/**
 * Date constants for validation across the application
 */

export const MIN_DATE = new Date('2020-01-02'); // Minimum date: day after 2020/01/01 (date must be > 2020/01/01)
export const MAX_DATE = new Date('2050-01-01'); // Maximum date: 2050/01/01

// String format for API calls
export const MIN_DATE_STR = '2020-01-02';
export const MAX_DATE_STR = '2050-01-01';

